<template>
  <v-app id="inspire" :style="{ backgroundColor: bgColor }">
    <Navigation v-if="loginState" />
    <!-- Publicidad de la plataforma: único punto de montaje global -->
    <PublicidadOverlay v-if="loginState" />

    <!-- <Sidebar v-if="loginState"/> -->

    <v-main>
      <v-container fluid :class="{ 'pa-0': !loginState }">
        <router-view></router-view>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import Navigation from "./components/dashboard/Navigation.vue";
import PublicidadOverlay from "./components/publicidad/PublicidadOverlay.vue";

import Sidebar from "./components/Sidebar.vue";

import { mapGetters } from "vuex";
import http from "@/services/http";
import { redirectLoginExpirado } from "@/utils/jwt";

export default {
  components: {
    Navigation,
    PublicidadOverlay,

    Sidebar,
  },

  data: () => ({
    cards: ["Today", "Yesterday"],

    bgColor: "#f6f6f6",
  }),

  computed: {
    ...mapGetters(["loginState"]),
  },

  async created() {
    // Estas rutas se cargan lazy: al crear App, currentRoute todavía no las refleja.
    const rutaInicial = this.$router.resolve(window.location.pathname).route.name;
    if (["ForgotPassword", "ResetPassword"].includes(rutaInicial)) return;

    const recordarSesion = localStorage.getItem("recordar_sesion");
    const token = localStorage.getItem("token");
    if (recordarSesion === "false") {
      const sesionActiva = sessionStorage.getItem("sesion_activa");
      if (!sesionActiva && this.$router.currentRoute.name !== "Login") {
        await this.$store.dispatch("logout");
        return;
      }
    }
    if (token) await this.verificarSesion(token);
  },

  methods: {
    async verificarSesion(token) {
      try {
        await http.get("usuarios/auth/verificar");
      } catch (error) {
        if (error.response?.status === 401) {
          this.$store.commit("logout");
          redirectLoginExpirado();
          return;
        }
      }
      await this.$store.dispatch("login", JSON.parse(token));
    },
  },
};
</script>

<style>
.v-data-table__mobile-table-row {
  display: initial;

  /* margin: 10px; */

  border: 4px solid #bfbcbcde;

  border-radius: 20px;

  padding: 5px;

  margin: 9px;

  padding-bottom: 0;
}

.v-data-table > .v-data-table__wrapper .v-data-table__mobile-row {
  height: initial;

  min-height: 48px;

  border-bottom: 0.4px solid #bfbcbcde;
}

.v-data-table-header-mobile {
  display: none !important;
}

/* Estilos SOLO para toasts de conexión a internet */
.network-toast.v-toast__item {
  min-width: 400px !important;
  font-size: 18px !important;
  font-weight: 600 !important;
  padding: 20px 24px !important;
  border-radius: 8px !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3) !important;
  cursor: pointer !important;
}

.network-toast-offline.v-toast__item {
  background-color: #d32f2f !important;
  animation: pulse-error 2s infinite;
}

.network-toast-online.v-toast__item {
  background-color: #388e3c !important;
}

@keyframes pulse-error {
  0%,
  100% {
    box-shadow: 0 4px 12px rgba(211, 47, 47, 0.4);
  }
  50% {
    box-shadow: 0 4px 20px rgba(211, 47, 47, 0.8);
  }
}

/* Responsive SOLO para toasts de red */
@media (max-width: 600px) {
  .network-toast.v-toast__item {
    min-width: 90vw !important;
    font-size: 16px !important;
  }
}
</style>
